// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._12l21wug{margin-inline-end:auto}
._1e0c1ule{display:block}
._1pfhidpf{margin-block-start:0}
._6rth1ejb{margin-block-end:var(--ds-space-300,24px)}
._ahbq1wug{margin-inline-start:auto}
._c71l649k{max-height:var(--_zsxb2b)}
._p12f163m{max-width:var(--_11x3y0)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/empty-state/dist/esm/styled/image.compiled.css"],"names":[],"mappings":"AAAA,WAAW,sBAAsB;AACjC,WAAW,aAAa;AACxB,WAAW,oBAAoB;AAC/B,WAAW,yCAAyC;AACpD,WAAW,wBAAwB;AACnC,WAAW,yBAAyB;AACpC,WAAW,wBAAwB","sourcesContent":["._12l21wug{margin-inline-end:auto}\n._1e0c1ule{display:block}\n._1pfhidpf{margin-block-start:0}\n._6rth1ejb{margin-block-end:var(--ds-space-300,24px)}\n._ahbq1wug{margin-inline-start:auto}\n._c71l649k{max-height:var(--_zsxb2b)}\n._p12f163m{max-width:var(--_11x3y0)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
